import { FileText, Info } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../shared/constants/routes';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';

const WidgetImss = () => {
	const navigate = useNavigate();
	const { tags } = useSelector((state: RootState) => state.profile);

	const isNewImssRegulations = tags?.some(
		(tag) => tag.tag === 'new-imss-regulations',
	);

	if (!isNewImssRegulations) return null;

	return (
		<div
			className='w-full h-full cursor-pointer bg-white rounded-xl shadow p-2 flex flex-col bg-gradient-to-b from-h-primary-90  to-white border-2 border-white'
			onClick={() => navigate(ROUTES.NEW_IMS_REGULATIONS)}
		>
			<div className='flex items-center gap-2 text-sm text-h-primary-40 font-medium'>
				<FileText
					size={24}
					weight='bold'
					className='bg-h-primary-80 p-1 rounded-lg'
				/>
				Nueva regulación IMSS (22 Junio)
			</div>
			<h2 className='font-bold text-base leading-[22px] mt-2 ml-1 mb-3'>
				Cobertura de IMSS, <br className='block md:hidden' /> accidentes y otros
				ingresos
			</h2>
			<div className='flex-1' />
			<div className='bg-h-primary-90/50 w-full rounded-lg p-1.5 text-sm flex items-center gap-2'>
				<Info
					weight='bold'
					size={18}
					className='min-w-[18px]'
				/>
				¡Prepárate y obtén aquí tus datos IMSS que las plataformas te podrían
				pedir para seguir trabajando!
			</div>
		</div>
	);
};

export default WidgetImss;
